import React, { useState } from 'react';

const GallerySection = ({ section }) => {
  const sectionData = section.section_data || {};
  const images = sectionData.images || [];
  const columns = sectionData.columns || 3;
  const spacing = sectionData.spacing || 'normal';
  const lightbox = sectionData.lightbox !== false;
  const [selectedImage, setSelectedImage] = useState(null);

  const spacingMap = {
    none: '0',
    small: '10px',
    normal: '15px',
    large: '20px'
  };

  if (images.length === 0) {
    return null;
  }

  return (
    <>
      <section
        className="gallery-section"
        style={{
          backgroundColor: section.background_color || '#ffffff',
          color: section.text_color || '#000000',
          padding: '60px 20px'
        }}
      >
        <div className="container">
          {section.title && (
            <h2 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', textAlign: 'center', fontWeight: '600' }}>
              {section.title}
            </h2>
          )}
          {section.subtitle && (
            <p style={{ fontSize: '1.2rem', marginBottom: '3rem', textAlign: 'center', opacity: 0.8 }}>
              {section.subtitle}
            </p>
          )}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columns}, 1fr)`,
              gap: spacingMap[spacing]
            }}
          >
            {images.map((img, index) => (
              <div
                key={index}
                style={{
                  position: 'relative',
                  aspectRatio: '1',
                  overflow: 'hidden',
                  borderRadius: '8px',
                  cursor: lightbox ? 'pointer' : 'default'
                }}
                onClick={() => lightbox && setSelectedImage(img.url)}
              >
                <img
                  src={img.url}
                  alt={img.alt || `Gallery image ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                />
                {img.caption && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      backgroundColor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      padding: '12px',
                      fontSize: '0.9rem'
                    }}
                  >
                    {img.caption}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.9)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Enlarged view"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain'
            }}
          />
        </div>
      )}
    </>
  );
};

export default GallerySection;
